import React from "react";

export default function Btn({ type = "btn-primary", children, handleClick }) {
    return (
        <button onClick={handleClick} className={type}>
            {children}
        </button>
    );
}
